import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { FootnoteReferenceV2 } from '@oneaudi/feature-app-utils';
import { useCurrencyFormatter } from '../../hooks/use-currency-formatter';
import { useI18n } from '../../i18n/i18n';
import { FeatureServicesProvider } from '../../provider/feature-services-provider';
import { PriceStyles } from './price-styles';
import useMarketConfig from '../../store/market-config';
import { FOOTNOTE_IDS } from '@oneaudi/confi-shared-components';
export const Prices = ({ totalPrice, monthlyRate, priceDisclaimer, vatConfig = 'hidden', financingDisclaimer, index, }) => {
    const { i18n } = useI18n();
    const { footnoteService } = useContext(FeatureServicesProvider);
    const { formatMonthlyRate, formatCurrency } = useCurrencyFormatter();
    const { marketConfig } = useMarketConfig();
    const showRates = marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.showRates;
    const showPrices = marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.showPrices;
    const monthlyRateFootnoteId = index !== undefined
        ? `footnote-reference-calculation-disclaimer-${index}`
        : `price-${FOOTNOTE_IDS.financingCalculationDisclaimer}`;
    useEffect(() => {
        var _a, _b;
        if (priceDisclaimer) {
            const priceDisclaimerFootnotes = [
                { Key: priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.id, Text: (_a = priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.text) !== null && _a !== void 0 ? _a : '' },
            ];
            const alreadyExistingFootnotes = footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.getData();
            const footnoteFound = alreadyExistingFootnotes === null || alreadyExistingFootnotes === void 0 ? void 0 : alreadyExistingFootnotes.find((d) => d.Key === (priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.id));
            if (footnoteFound) {
                footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.replaceFootNotes(priceDisclaimerFootnotes);
            }
            else {
                footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.addFootNotes(priceDisclaimerFootnotes);
            }
        }
        if (financingDisclaimer) {
            const _disclaimer = (_b = financingDisclaimer
                .map((disclaimer) => {
                const item = financingDisclaimer.find((d) => d.key === disclaimer.key);
                return item === null || item === void 0 ? void 0 : item.text;
            })
                .join(' ')) !== null && _b !== void 0 ? _b : '';
            const financingDisclaimerFootnotes = [
                { Key: monthlyRateFootnoteId, Text: _disclaimer !== null && _disclaimer !== void 0 ? _disclaimer : '' },
            ];
            const alreadyExistingFootnotes = footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.getData();
            const footnoteFound = alreadyExistingFootnotes === null || alreadyExistingFootnotes === void 0 ? void 0 : alreadyExistingFootnotes.find((d) => d.Key === monthlyRateFootnoteId);
            if (footnoteFound) {
                footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.replaceFootNotes(financingDisclaimerFootnotes);
            }
            else {
                footnoteService === null || footnoteService === void 0 ? void 0 : footnoteService.addFootNotes(financingDisclaimerFootnotes);
            }
        }
    }, [financingDisclaimer, footnoteService, monthlyRateFootnoteId, priceDisclaimer]);
    return (_jsxs(PriceStyles, { children: [showPrices &&
                (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.__typename) === 'Price' &&
                typeof (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.value) === 'number' && (_jsxs(Text, { tag: "div", variant: { type: 'copy', order: '1', style: 'bold' }, children: [formatCurrency(totalPrice, vatConfig), (priceDisclaimer === null || priceDisclaimer === void 0 ? void 0 : priceDisclaimer.text) && _jsx(FootnoteReferenceV2, { footnoteId: priceDisclaimer.id })] })), monthlyRate && showRates && typeof monthlyRate === 'number' && (_jsxs(_Fragment, { children: [_jsx(Text, { tag: "span", variant: { type: 'copy', order: '2', style: 'bold' }, children: i18n('compareLayer.header.price.or') }), _jsxs(Text, { tag: "span", variant: { type: 'copy', order: '2', style: 'normal' }, children: [formatMonthlyRate(monthlyRate), _jsx("span", { onClick: (e) => {
                                    e.stopPropagation();
                                }, children: _jsx(FootnoteReferenceV2, { footnoteId: monthlyRateFootnoteId }) })] })] }))] }));
};
